import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { useEffect, useState } from "react";
import { DndProvider } from "react-dnd-multi-backend";
import { DraggableMessage } from "../components/Draggables";
import {
  BINARY_FONT,
  BINARY_SYSTEM,
  COLOR_DARK,
  FONT,
  REGEX_VALID_BINARY
} from "../defaults";
import { convertToAlternate, increaseProgress } from "../helpers";
import {
  buttonCheck,
  level6BinaryTask,
  level6BinaryTextBox,
  levelCorrect,
  levelIncorrect,
  levelNoInput
} from "../strings";


const LevelNumber = 6;

function generateNumber(currentProgress) {
  const numbers = [120, 82, 254];
  if (currentProgress >= numbers.length) {
    return Math.ceil(Math.random() * 252) + 2; // Generate integer between 2 and 254. (Only even numbers will be used)
  }
  return numbers[currentProgress];
}


const exerciseStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "110dvh",
    fontFamily: FONT,
    fontSize: "7dvh",
    backgroundColor: COLOR_DARK,
    filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))",
    textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
    borderRadius: "0.25em",
    padding: "5dvh",
    marginTop: "8dvh",
    border: "0.2dvh solid black"
};

const textBoxStyle = {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "2dvh",
    width: "60dvh",
    height: "10.5dvh",
    alignItems: "center",
    fontFamily: FONT,
    fontSize: "2dvh",
    backgroundColor: COLOR_DARK,
    filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))",
    textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
    borderRadius: "0.5em",
    padding: "2dvh",
    border: "0.2dvh solid black"
  };

const inputStyle = {
    maxWidth: "40dvh",
    fontFamily: BINARY_FONT,
    fontSize: "7dvh",
    border: "0.2dvh solid black"
};

function Level6Binary({levelProgress, setLevelProgress, showMessage, setShowMessage, disableInput, setDisableInput}) {
  const [number, setNumber] = useState(
    generateNumber(levelProgress[LevelNumber])
  );
  const [solution, setSolution] = useState("");
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [correct, setCorrect] = useState(false);


  useEffect(() => {
    let newNumber = generateNumber(levelProgress[LevelNumber]);
    while (newNumber % 2 !== 0) {
        newNumber = generateNumber(levelProgress[LevelNumber]); // Make sure number is even.
    }
    setNumber(newNumber);
  }, [levelProgress]);

  useEffect(() => {
    setSolution(number / 2);
  }, [number]);
 
  const checkAnswer = () => {
    const isCorrect = input === convertToAlternate(BINARY_SYSTEM, solution);
    setCorrect(isCorrect);
    if (isCorrect) {
      setMessage(levelCorrect)
    } else if (input === "") {
      setMessage(levelNoInput);
    } else {
      setMessage(levelIncorrect);
    }
    displayMessage();
  };

  const displayMessage = () => {
    setDisableInput(true);
    setShowMessage(true);
  };

  const handleCloseMessage = () => {
    if (correct) {
      increaseProgress(levelProgress, setLevelProgress, LevelNumber, BINARY_SYSTEM); // Triggers a useEffect.
    }
    setInput("");
    setMessage("");
    setDisableInput(false);
    setCorrect(false);
  };

  return (
    <div>
      <div
        className="Welcome-label"
        style={{ fontFamily: FONT, fontSize: "4dvh", marginTop: "4dvh" }}
      >
        {level6BinaryTask}
      </div>
      
      <DndProvider options={HTML5toTouch}>
        {showMessage && <DraggableMessage show={showMessage} setShow={setShowMessage} handleClose={handleCloseMessage} message={message}/>} {/* Conditionally rendering it with showMessage makes the message re-render, and hence center itself, every time. */}
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          <div style={exerciseStyle}>
            <span style={{fontFamily: BINARY_FONT, marginBottom: "0.2dvh"}}>{convertToAlternate(BINARY_SYSTEM, number)}</span>&nbsp;&nbsp;:&nbsp;&nbsp;2&nbsp;&nbsp;=&nbsp;&nbsp;
            <input
            className="input-field"
            style={inputStyle}
            type="text"
            inputMode="numeric"
            value={input}
            maxLength={7}
            disabled={disableInput}
            placeholder=""
            pattern={REGEX_VALID_BINARY}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\s/g, ''); // LLM-generated. Disallow white-space input.
              setInput(e.target.value);
            }}
            />
          </div>
          <div style={textBoxStyle}>
            {level6BinaryTextBox}
          </div>
        </div>
        <button
          onClick={checkAnswer}
          className="checkAnswer-button"
          disabled={disableInput}
        >
          {buttonCheck}
        </button>
      </DndProvider>
    </div>
  );
}

export default Level6Binary;